import React from 'react';
import ReactDom from 'react-dom/client';
import App from './App';


const container =  document.getElementById('root');
const root = ReactDom.createRoot(container);

root.render(
    
  <React.StrictMode>
    <App />
  </React.StrictMode>
    
);


/*import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.6.1/css/font-awesome.min.css"></link>


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);*/


